/* eslint-disable max-len */
import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const FormatHeader3NewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3.5 3.75C4.05228 3.75 4.5 4.19772 4.5 4.75V11H12V4.75C12 4.19772 12.4477 3.75 13 3.75C13.5523 3.75 14 4.19772 14 4.75V12V19.25C14 19.8023 13.5523 20.25 13 20.25C12.4477 20.25 12 19.8023 12 19.25V13H4.5V19.25C4.5 19.8023 4.05228 20.25 3.5 20.25C2.94772 20.25 2.5 19.8023 2.5 19.25V4.75C2.5 4.19772 2.94772 3.75 3.5 3.75Z'
            fill='currentColor'
        />
        <path
            d='M19.5 12.25H17.5C16.3954 12.25 15.5 13.1454 15.5 14.25C15.5 14.8023 15.9477 15.25 16.5 15.25C17.0523 15.25 17.5 14.8023 17.5 14.25H19.5L19.5 15.25C18 15.25 18 15.8749 18 16.25C18 16.8023 18 17.25 19.5 17.25L19.5 18.25H17.5C17.5 17.6977 17.0523 17.25 16.5 17.25C15.9477 17.25 15.5 17.6977 15.5 18.25C15.5 19.3546 16.3954 20.25 17.5 20.25H19.5C20.6046 20.25 21.5 19.3546 21.5 18.25V17.3204C21.5 16.9038 21.3703 16.5045 21.1381 16.1729C21.3598 15.888 21.5 15.5556 21.5 15.1796V14.25C21.5 13.1454 20.6046 12.25 19.5 12.25Z'
            fill='currentColor'
        />
    </svg>
));
